import {EntityField} from "../../../core/genericdocuments/EntityField";
import {EntityFieldDataType} from "../../../core/genericdocuments/EntityFieldDataType";
import {EntityFieldsDescriptor} from "../../../core/genericdocuments/EntityFieldsDescriptor";
import {baseDocumentFields} from "../BaseDocumentFields";
import {LookupEntities} from "../../../core/genericdocuments/ReferenceDetails";
import {PotvrdaOSprecenostiZaRadDocument} from "./PotvrdaOSprecenostiZaRadDocument";

// obavezno: datum zavodjenja, delovodni broj, datum dokumenta, broj dokumenta, zaposleni, sektor
// opciono: period odsustva
export const potvrdaOSprecenositZaRadDocumentFields: IntercateKeysMap<PotvrdaOSprecenostiZaRadDocument, EntityField<PotvrdaOSprecenostiZaRadDocument>> = {
	...baseDocumentFields,
	employeeId: {
		name: "employeeId", dataType: EntityFieldDataType._reference, label: "Zaposleni",
		referenceDetails: {
			lookupOptions: null,
			lookupEntity: LookupEntities.Employees
		},
		validator: { required: true },
		sortable: true
	},
	period: {
		name: "period", dataType: EntityFieldDataType._string, label: "Period odsustva",
		validator: { required: false },
		sortable: true,
		filterable: true
	},
	parentId: {
		name: "parentId", dataType: EntityFieldDataType._derived, label: "Parent",
		value: item => item.employeeId,
		hide: formState => true
	}
}

const documentFieldsArray: Array<EntityField<PotvrdaOSprecenostiZaRadDocument>> = [
	potvrdaOSprecenositZaRadDocumentFields.indexingNumber,
	potvrdaOSprecenositZaRadDocumentFields.indexingDate,
	potvrdaOSprecenositZaRadDocumentFields.documentNumber,
	potvrdaOSprecenositZaRadDocumentFields.documentDate,
	potvrdaOSprecenositZaRadDocumentFields.assignedTo,
	potvrdaOSprecenositZaRadDocumentFields.sectorId,
	potvrdaOSprecenositZaRadDocumentFields.employeeId,
	potvrdaOSprecenositZaRadDocumentFields.period,
	potvrdaOSprecenositZaRadDocumentFields.tags,
	potvrdaOSprecenositZaRadDocumentFields.description,
	potvrdaOSprecenositZaRadDocumentFields.parentId,
]

export const potvrdaOSprecenostiZaRadDocumentFieldsDescriptor: EntityFieldsDescriptor<PotvrdaOSprecenostiZaRadDocument> = {
	listFields: documentFieldsArray,
	createFormFields: documentFieldsArray,
	updateFormFields: documentFieldsArray
}
